import {ChatMessageStream} from "../Guardian/ChatMessageStream";


export interface AiInvestigationProps {
    chatHistoryUuid?: string;
}

export function AiInvestigation(props: AiInvestigationProps) {
    if (!props.chatHistoryUuid) {
        return <div className="text-red-500">Chat history UUID is required</div>;
    }
    return <ChatMessageStream
        dontUpdate={true}
        maxHeight="100%"
        autoScroll={false}
        className="h-full"
        chatId={props.chatHistoryUuid}
    />
}